<template>
  <div>
    <v-main>
      <v-container>
        <router-link :to="`/${route}`">
          &lt;&lt; {{ $t("voltar") }}
        </router-link>
        <v-row>
          <v-col 
            cols="12"
            xs="12"
            md="4"
          >
            <div class="text-h4">
              <span v-if="salesQuote">{{ $t("nAbreviado") }} {{ salesQuote }}</span>
              <span v-else>{{ $t("novaCotacao") }}</span>
              <v-icon 
                right
                color="primary"
                @click="dialogInformation = true"
              >
                mdi-information
              </v-icon>
            </div>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            md="8"
            class="align-right"
          >
            <v-btn
              type="button"
              class="ma-1"
              color="success"
              small
              :disabled="savingOrder"
              @click="form.ID_IMPORTACAO = 'R'; sendOrder();"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              {{ $t('salvarRascunho') }}
            </v-btn>
            <v-btn
              type="button"
              class="ma-1"
              color="primary"
              small
              :disabled="savingOrder"
              @click="form.ID_IMPORTACAO = 'N'; sendOrder();"
            >
              <v-icon left>
                mdi-send
              </v-icon>
              {{ $t('enviarPedido') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-skeleton-loader
          v-if="listLoading"
          :loading="listLoading"
          transition="fade-transition"
          type="table"
        />
        <v-form ref="formQuote">
          <v-card v-show="!listLoading">
            <v-container>
              <v-row class="py-2">
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">
                      {{ $t('companhia') }}
                      <span class="required">*</span>
                    </label>
                    <v-autocomplete
                      v-model="filled.CLIENTE"
                      :rules="companyRules"
                      :items="listClients"
                      class="mb-1"
                      item-text="NAME"
                      hide-details="auto"
                      dense
                      outlined
                      return-object
                      required
                      :autofocus="!filled.CLIENTE"
                      @change="form.ADDRESS = null; selectedClient(filled.CLIENTE);"
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="9"
                  sm="7"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">
                      {{ $t('enviarPara') }}
                      <span class="required">*</span>
                    </label>
                    <v-autocomplete
                      v-model="form.ADDRESS"
                      :rules="adressRules"
                      :items="listAdressesClient"
                      class="mb-1"
                      :item-text="textAdress"
                      hide-details="auto"
                      dense
                      outlined
                      return-object
                      required
                      @change="selectedAddress"
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="3"
                  sm="1"
                >
                  <div class="max-size">
                    <v-btn
                      type="button"
                      class="mb-1 mt-6 white--text"
                      color="orange"
                      :disabled="!filled.CLIENTE"
                      @click="dialogLocation = true"
                    >
                      <v-icon>
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">
                      {{ $t('ordemCompra') }}
                      <span class="required">*</span>
                    </label>
                    <v-text-field
                      v-model="form.CUST_PO_NUMBER"
                      :rules="customerPoRules"
                      hide-details="auto"
                      class="mb-1"
                      maxlength="50"
                      dense
                      outlined
                      required
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="8"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('observacoes') }}</label>
                    <v-text-field
                      v-model="form.DS_OBSERVACAO"
                      hide-details
                      class="mb-1"
                      maxlength="255"
                      dense
                      outlined
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('repVendas') }}</label>
                    <v-text-field
                      v-model="form.SALES_REP_NAME"
                      hide-details
                      class="mb-1"
                      dense
                      filled
                      outlined
                      disabled
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('category') }}</label>
                    <v-text-field
                      v-model="customerFields.CATEGORY"
                      hide-details
                      class="mb-1"
                      dense
                      filled
                      outlined
                      disabled
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('class') }}</label>
                    <v-text-field
                      v-model="customerFields.CLASS"
                      hide-details
                      class="mb-1"
                      dense
                      filled
                      outlined
                      disabled
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('sale_channel') }}</label>
                    <v-text-field
                      v-model="customerFields.SALE_CHANNEL"
                      hide-details
                      class="mb-1"
                      dense
                      filled
                      outlined
                      disabled
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('contratoFrete') }}</label>
                    <v-currency-field
                      v-model="filled.FFA"
                      v-bind="configCurrency"
                      hide-details
                      class="mb-1"
                      dense
                      filled
                      outlined
                      disabled
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('tipoFrete') }}</label>
                    <v-select 
                      v-model="form.FREIGHT_TERMS"
                      :items="listFreight"
                      item-text="text"
                      item-value="value"
                      class="mb-1"
                      hide-details
                      dense
                      outlined
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('dataPedido') }}</label>
                    <v-text-field
                      v-if="salesQuote"
                      v-model="form.LAST_UPDATE_DATE"
                      hide-details
                      type="date"
                      class="mb-1"
                      dense
                      filled
                      outlined
                      disabled
                    />
                    <v-text-field
                      v-else
                      v-model="form.CREATION_DATE"
                      hide-details
                      type="date"
                      class="mb-1"
                      dense
                      filled
                      outlined
                      disabled
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('condicaoPagamento') }}</label>

                    <v-autocomplete
                        v-model="filled.PAYMENT_TERM"
                        :items="paymentTerms"
                        class="mb-1"
                        item-text="label"
                        hide-details="auto"
                        dense
                        outlined
                        return-object
                        required
                    />
                  </div>
                </v-col>
                <v-col
                  class="d-flex pt-0 pb-0"
                  cols="12"
                  sm="4"
                >
                  <div class="max-size">
                    <label class="v-label theme--light">{{ $t('totalOrdem') }}</label>
                    <v-currency-field 
                      v-model="form.TOTAL"
                      v-bind="configCurrency" 
                      hide-details
                      dense
                      class="mb-1 quote-total-input"
                      filled
                      outlined
                      disabled
                    />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-form>
        <br>
        <v-card v-show="!listLoading">
          <v-tabs
            v-model="quoteTab"
            background-color="grey lighten-5"
            color="orange"
            no-animation
            show-arrows
            hide-slider
            grow
          >
            <v-tab
              v-for="tab of listTabs"
              :key="tab.ID"
              active-class="tab-usa-active"
              class="tab-usa"
            >
              <v-badge
                v-if="tab.ID === 0 && listQuotesItems.length"
                color="orange"
                inline
              >
                <strong>{{ $t(tab.LINE) }}</strong>
                <span slot="badge">{{ listQuotesItems.length }}</span>
              </v-badge>
              <span v-if="tab.ID > 0 || !listQuotesItems.length">
                <strong>{{ $t(tab.LINE) }}</strong>
                <small v-if="tab.ID === 0" class="ma-1">
                  ({{ listQuotesItems.length }})
                </small>
              </span>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="quoteTab">
            <v-tab-item
              v-for="tab of listTabs"
              :key="tab.ID"
            >
              <v-container>
                <v-data-table
                  v-if="tab.ID === 0"
                  :headers="headers"
                  :items="listQuotesItems"
                  :search="filter"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:no-data>
                    {{ $t("naoHaDadosDisponiveis") }}
                  </template>
                  <template v-slot:top>
                    <v-row class="pt-5">
                      <v-col
                        class="d-flex pt-0 pb-0"
                        cols="12"
                        sm="4"
                      >
                        <v-autocomplete 
                          ref="product"
                          v-model="options.product"
                          :items="listProduct"
                          :label="$t('produto')"
                          :placeholder="$t('digiteTresCaracteresParaPesquisar')"
                          :search-input.sync="search"
                          :loading="isLoadingSearch"
                          :disabled="!form.ADDRESS"
                          item-text="name"
                          :autofocus="!!form.ADDRESS"
                          clearable
                          return-object
                          no-filter
                          dense
                          outlined
                          @change="selectedProduct"
                          @click:clear="clearProduct"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-title>
                                <span v-if="isLoadingSearch">
                                  {{ $t('pesquisandoProdutosPorFavorAguarde') }}
                                </span>
                                <span v-if="!search && !isLoadingSearch">
                                  {{ $t('digiteTresCaracteresParaPesquisar') }}
                                </span>
                                <span v-if="search && !isLoadingSearch">
                                  {{ $t('naoHaItensDisponiveis') }}
                                </span>
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>
                                <template>
                                  {{ item.sku }}
                                </template>
                              </v-list-item-title>
                              <v-list-item-subtitle v-text="item.name" />
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        class="d-flex pt-0 pb-0 info-quantity-wrapper"
                        cols="8"
                        sm="2"
                      >
                        <v-text-field
                          ref="qty"
                          v-model="options.qty"
                          type="number"
                          min="0"
                          :step="qtdBox(options.product)"
                          :hint="$t('caixaCom') + ' ' + qtdBox(options.product)"
                          :label="$t('quantidade')"
                          :disabled="!filled.CLIENTE || !options.product"
                          dense
                          outlined
                        />
                      </v-col>
                      <v-col
                        class="d-flex pt-0 pb-0"
                        cols="4"
                        sm="3"
                      >
                        <v-btn
                          class="white--text"
                          color="orange"
                          @click="onProductSelected(options.product)"
                        >
                          <v-icon>
                            mdi-plus
                          </v-icon>
                        </v-btn>
                      </v-col>
                      <v-col
                        class="d-flex pt-0 pb-0 align-right"
                        cols="12"
                        sm="3"
                      >
                        <v-text-field
                          v-model="filter"
                          append-icon="mdi-magnify"
                          :label="$t('filtro')"
                          :placeholder="$t('filtro')"
                          dense
                          outlined
                          :disabled="!listQuotesItems.length"
                        />
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:item="props">
                    <tr>
                      <td>{{ props.item.TIGRE_CODE }}</td>
                      <td>{{ props.item.DESCRIPTION }}</td>
                      <td>{{ props.item.QTY }}</td>
                      <td>{{ props.item.BOX_QTY }}</td>
                      <td
                        v-if="!props.item.loading"
                        class="align-right"
                      >
                        {{ props.item.PRICE_UNIT | currencyUSA(4) }}
                      </td>
                      <td class="align-right">{{ props.item.PRICE_UNIT_DISCOUNTED | currencyUSA(4) }}</td>
                      <td>{{ props.item.DISCOUNT_AMOUNT }}%</td>
                      <td
                        v-if="!props.item.loading"
                        class="align-right"
                      >
                        {{ props.item.TOTAL | currencyUSA(3) }}
                      </td>
                      <td
                        v-if="props.item.loading"
                        colspan="2"
                        class="text-center"
                      >
                        <v-progress-circular 
                          indeterminate 
                          small
                          color="orange"
                        />
                      </td>
                      <td>
                        <v-icon @click="openDialog(props.item)">
                          mdi-pencil
                        </v-icon>
                        <v-icon @click="removeItemAction(props.item)">
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-data-table
                  v-if="tab.ID === 1"
                  :items-per-page="itemsPerPage"
                  :headers="headersLines"
                  :server-items-length="listProductsLinesCount"
                  :page.sync="page"
                  :options.sync="optionsProductsLines"
                  :items="listProductsLines"
                  hide-default-footer
                >
                  <template v-slot:no-data>
                    {{ $t("naoHaDadosDisponiveis") }}
                  </template>
                  <template v-slot:top>
                    <div class="text-h6 mb-2">
                      {{ $t('filters') }}
                    </div>

                    <v-row class="mb-2">
                      <v-col
                          v-for="(item, itemIdx) in filterableHeadersLines" :key="itemIdx"
                          cols="12"
                          sm="3"
                      >
                        <v-text-field
                            v-if="item.filterable && !item.items"
                            v-model="filtersByColumn[item.value]"
                            :label="$t(item.text)"
                            outlined
                            dense
                            hide-details
                            @keyup="onEnter($event, selectedLine)"
                        />

                        <v-autocomplete
                            v-if="item.items"
                            v-model="filtersByColumn[item.value]"
                            :label="$t(item.text)"
                            :items="item.items"
                            item-text="text"
                            item-value="value"
                            clearable
                            hide-details
                            outlined
                            dense
                            @keyup="onEnter($event, selectedLine)"
                        />
                      </v-col>
                      <v-col cols="12" class="text-right">
                        <v-btn color="terciary" @click="cleanSearch">
                          <v-icon>mdi-filter-remove</v-icon>
                        </v-btn>
                        <v-btn color="primary" class="ml-2" @click="selectedLine">
                          <v-icon> mdi-magnify </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:body="props">
                    <tbody 
                      v-for="(group, groupIndex) in props.items"
                      :key="groupIndex"
                    >
                      <tr 
                        v-for="(item, itemIndex) in group.items"
                        :key="itemIndex"
                      >
<!--
                        <td
                          v-if="itemIndex === 0"
                          :rowspan="group.items.length"
                        >
                          <v-avatar 
                            v-if="group.name"
                            tile
                            class="align-center"
                            width="50"
                            height="50"
                          >
                            <a 
                              :href="group.name" 
                              target="_blank"
                            >
                              <v-img 
                                :src="group.name"
                                max-width="50"
                                max-height="50"
                              />
                            </a>
                          </v-avatar>
                          <span v-else>
                            {{ $t('semImagem') }}
                          </span>
                        </td>
                        -->
                        <td>{{ item.sku }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.line }}</td>
                        <td>{{ item.type }}</td>
                        <td>{{ item.box_qty }}</td>
<!--                        <td>{{ item.pallet_qty }}</td>-->
                        <td class="align-right">
                          {{ item.price_unit | currencyUSA(4) }}
                        </td>
                        <td>{{ item.max_discount }} %</td>
                        <td>
                          {{ getDiscountedPrice(item) | currencyUSA(4) }}
                        </td>
                        <td>
                          {{ getTotalDiscountedPrice(item) | currencyUSA(4) }}
                        </td>
                        <td>
                          <div>
                            <v-text-field
                                v-model="item.discount_amount"
                                class="max-width-100"
                                type="number"
                                hide-details
                                dense
                                outlined
                                @input="keepRange(item, 'discount_amount', 0, item.max_discount)"
                            />
                          </div>
                        </td>
                        <td>
                          <div>
                            <v-text-field
                              :ref="refQtyLines(tab.ID)"
                              v-model="item.QTY"
                              class="max-width-150"
                              type="number"
                              min="0"
                              :step="qtdBox(item)"
                              :disabled="!filled.CLIENTE"
                              :autofocus="groupIndex === 0 && itemIndex === 0"
                              hide-details
                              dense
                              outlined
                            >
                              <template v-slot:append-outer>
                                <v-btn
                                  :disabled="!item.QTY || item.QTY === '0'"
                                  color="primary"
                                  height="25"
                                  x-small
                                  @click="onProductSelected(item)"
                                >
                                  <v-icon>
                                    mdi-check
                                  </v-icon>
                                </v-btn>
                              </template>
                            </v-text-field>
                          </div>
                        </td>
                      </tr> 
                    </tbody>
                  </template>
                  <template v-slot:footer>
                    <v-pagination
                      v-model="page"
                      :length="pageCount(listProductsLinesCount)"
                      :total-visible="9"
                    />
                  </template>
                </v-data-table>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <br>
        <br>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <v-row>
                <v-col cols="8">
                  <span class="headline">{{ $t('editarItem') }} {{ dialogItem.TIGRE_CODE }}</span>
                </v-col>
                <v-col 
                  class="align-right"
                  cols="4"
                >
                  <v-btn
                    color="grey"
                    text
                    @click="dialog = false"
                  >
                    X
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="8"
                  >
                    <div class="max-size">
                      <label class="v-label theme--light">{{ $t('produto') }}</label>
                      <v-text-field
                        v-model="dialogItem.DESCRIPTION"
                        dense
                        filled
                        outlined
                        disabled
                      />
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                  >
                    <div class="max-size">
                      <label class="v-label theme--light">{{ $t('codigoTigre') }}</label>
                      <v-text-field
                        v-model="dialogItem.TIGRE_CODE"
                        dense
                        filled
                        outlined
                        disabled
                      />
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                  >
                    <div class="max-size">
                      <label class="v-label theme--light">{{ $t('quantidade') }}</label>
                      <v-text-field
                        v-model="dialogItem.QTY"
                        type="number"
                        min="0"
                        :step="qtdBox(dialogItem)"
                        dense
                        outlined
                        autofocus
                      />
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                  >
                    <div class="max-size">
                      <label class="v-label theme--light">{{ $t('precoUnit') }}</label>
                      <v-currency-field
                        v-model="dialogItem.PRICE_UNIT"
                        v-bind="configCurrency"
                        :decimal-length="4" 
                        dense
                        outlined
                        @blur="calculateMultiple(dialogItem)"
                      />
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                  >
                    <div class="max-size">
                      <label class="v-label theme--light">{{ $t('multiplo') }}</label>
                      <v-currency-field
                        v-model="dialogItem.MULTIPLE"
                        :decimal-length="4" 
                        dense
                        outlined
                        @blur="calculatePriceUnit(dialogItem)"
                      />
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                  >
                    <div class="max-size">
                      <label class="v-label theme--light">{{ $t('qtdCaixa') }}</label>
                      <v-text-field
                        v-model="dialogItem.BOX_QTY"
                        dense
                        filled
                        outlined
                        disabled
                      />
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                  >
                    <div class="max-size">
                      <label class="v-label theme--light">{{ $t('total') }}</label>
                      <v-currency-field
                        v-model="dialogItem.TOTAL"
                        v-bind="configCurrency"
                        dense
                        filled
                        outlined
                        disabled
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                @click="onProductSelected(dialogItem); dialog = false"
              >
                {{ $t('salvarItem') }}
              </v-btn>
              <v-spacer />
              <v-btn
                color="grey"
                text
                @click="dialog = false"
              >
                {{ $t('fechar') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogInformation"
          max-width="900px"
        >
          <v-card>
            <v-card-title class="pb-0">
              <v-row>
                <v-col 
                  cols="8"
                  class="pb-0"
                >
                  <span class="headline">{{ $t('requisitosCriacaoPedido') }}</span>
                </v-col>
                <v-col 
                  class="align-right pb-0"
                  cols="4"
                >
                  <v-btn
                    color="grey"
                    text
                    @click="dialogInformation = false"
                  >
                    X
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogLocation"
          persistent
          max-width="900px"
        >
          <v-card>
            <v-card-title class="pb-0">
              <v-row>
                <v-col 
                  cols="8"
                  class="pb-0"
                >
                  <span class="headline">{{ $t('adicionarNovoEndereco') }}</span>
                </v-col>
                <v-col 
                  class="align-right pb-0"
                  cols="4"
                >
                  <v-btn
                    color="grey"
                    text
                    @click="dialogLocation = false"
                  >
                    X
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-form ref="formLocation">
                <v-container>
                  <v-row>
                    <v-col
                      class="d-flex pt-0 pb-0"
                      cols="12"
                      sm="12"
                    >
                      <div class="max-size">
                        <label class="v-label theme--light">
                          {{ $t('endereco') }}
                          <span class="required">*</span>
                        </label>
                        <v-text-field
                          v-model="location.ADDRESS"
                          autofocus
                          dense
                          outlined
                          required
                        />
                      </div>
                    </v-col>
                    <v-col
                      class="d-flex pt-0 pb-0"
                      cols="12"
                      sm="4"
                    >
                      <div class="max-size">
                        <label class="v-label theme--light">
                          {{ $t('estado') }}
                          <span class="required">*</span>
                        </label>
                        <v-text-field
                          v-model="location.STATE"
                          dense
                          outlined
                          required
                        />
                      </div>
                    </v-col>
                    <v-col
                      class="d-flex pt-0 pb-0"
                      cols="12"
                      sm="4"
                    >
                      <div class="max-size">
                        <label class="v-label theme--light">
                          {{ $t('cidade') }}
                          <span class="required">*</span>
                        </label>
                        <v-text-field
                          v-model="location.CITY"
                          dense
                          outlined
                          required
                        />
                      </div>
                    </v-col>
                    <v-col
                      class="d-flex pt-0 pb-0"
                      cols="12"
                      sm="4"
                    >
                      <div class="max-size">
                        <label class="v-label theme--light">{{ $t('enderecoPostal') }}</label>
                        <v-text-field
                          v-model="location.POSTAL_CODE"
                          dense
                          outlined
                        />
                      </div>
                    </v-col>
                    <v-col
                      class="d-flex pt-0 pb-0"
                      cols="12"
                      sm="8"
                    >
                      <div class="max-size">
                        <label class="v-label theme--light">{{ $t('email') }}</label>
                        <v-text-field
                          v-model="location.EMAIL"
                          dense
                          outlined
                        />
                      </div>
                    </v-col>
                    <v-col
                      class="d-flex pt-0 pb-0"
                      cols="12"
                      sm="4"
                    >
                      <div class="max-size">
                        <label class="v-label theme--light">{{ $t('telefone') }}</label>
                        <v-text-field
                          v-model="location.TELEPHONE"
                          dense
                          outlined
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                @click="saveAddress"
              >
                {{ $t('salvarEndereco') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { currencyUSA, dateToUSNoHour } from "../../helpers/filter";
import moment from "moment";
import lodash from "lodash";
import EventBus from "../../plugins/event-bus";

const route = "quotes";
const name = "quoteUsa";
const appStore = "AppQuotesStore";
const defaultSort = "sku";
const defaultSortDesc = false;

export default {
  props: {
    salesQuote: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      isLoadingSearch: false,
      dialog: false,
      dialogInformation: false,
      dialogLocation: false,
      quoteTab: 1,
      page: 1,
      itemsPerPage: 20,
      cleanState: false,
      multiple: {},
      options: {
        product: undefined,
        qty: 0
      },
      paymentTerms: [
        {
          days: 30,
          label: '30 dias',
        },
        {
          days: 45,
          label: '45 dias',
        },
        {
          days: 60,
          label: '60 dias',
        },
        {
          days: 90,
          label: '90 dias',
        },
      ],
      optionsProductsLines: {
        sortBy: [ defaultSort ],
        sortDesc: [ defaultSortDesc ]
      },
      config: {
        chunkSize: 10
      },
      configCurrency: {
        prefix: "$"
      },
      companyRules: [ v => !!v || this.$i18n.t("companhiaObrigatorio") ],
      adressRules: [ v => !!v || this.$i18n.t("enderecoEnvioObrigatorio") ],
      customerPoRules: [ v => !!v || this.$i18n.t("ordemCompraObrigatorio") ],
      filled: !this.salesQuote && JSON.parse(localStorage.getItem(name)) && JSON.parse(localStorage.getItem(name)).filled || {
        CLIENTE: null,
        FFA: 0,
        PAYMENT_TERM: null
      },
      customerFields: {},
      dialogItem: {},
      location: {
        ADDRESS: null,
        STATE: null,
        CITY: null,
        POSTAL_CODE: null,
        EMAIL: null,
        TELEPHONE: null,
        LOCATION: null,
        CUSTOMER: null
      },
      search: "",
      filter: "",
      filtersByColumn: {},
      listAdressesClient: [],
      listTabs: [
        {
          ID: 0,
          LINE: 'orderSummary',
        },
        {
          ID: 1,
          LINE: 'buscarProdutos',
        }
      ],
      listFreight: [
        { value: 'Prepay & Add', text: 'Prepay and Add', disabled: false  },
        { value: 'Prepaid', text: 'Prepaid', disabled: true },
        { value: 'Customer has responsability on Freight', text: 'Will Call', disabled: false },
        { value: 'Collect', text: 'Use Customer Shipping Account', disabled: false }
      ],
      filterableHeadersLines: [],
      headersLines: [
        // { text: this.$i18n.t("imagem"), value: "", sortable: false },
        { text: this.$i18n.t("codigoTigre"), value: "sku", filterable: true},
        { text: this.$i18n.t("produto"), value: "name", filterable: true},
        { text: this.$i18n.t("productLine"), value: "line", filterable: true, type: 'select'},
        { text: this.$i18n.t("types"), value: "type", filterable: true, type: 'select'},
        { text: this.$i18n.t("qtdCaixa"), value: "box_qty" },
        // { text: this.$i18n.t("qtdPalete"), value: "pallet_qty" },
        { text: this.$i18n.t("precoUnit"), value: "price_unit", align: 'right', sortable: false },
        { text: this.$i18n.t("descontoMaximo"), value: "QTY", sortable: false },
        { text: this.$i18n.t("precoUnitDiscounted"), value: "price_unit_discounted", align: 'right', sortable: false },
        { text: this.$i18n.t("precoUnitTotalDiscounted"), value: "price_unit_total_discounted", align: 'right', sortable: false },
        { text: this.$i18n.t("desconto"), value: "QTY", sortable: false },
        { text: this.$i18n.t("quantidade"), value: "QTY", sortable: false },
      ],
      headers: [
        { text: this.$i18n.t("codigoTigre"), value: "sku", filterable: true},
        { text: this.$i18n.t("produto"), value: "name", filterable: true},
        { text: this.$i18n.t("quantidade"), value: "QTY" },
        { text: this.$i18n.t("qtdCaixa"), value: "box_qty" },
        { text: this.$i18n.t("precoUnit"), value: "price_unit", align: 'right', sortable: false },
        { text: this.$i18n.t("precoUnitDiscounted"), value: "price_unit_discounted", align: 'right', sortable: false },
        { text: this.$i18n.t("discount"), value: "discount_amount", align: 'left', sortable: false },
        { text: this.$i18n.t("total"), value: "TOTAL", align: 'right', sortable: false },
        { text: this.$i18n.t("acoes"), value: "ACOES", sortable: false }
      ],
      route: route
    }
  },
  computed: {
    ...mapState(`${appStore}`, {
      listTypes: (state) => state[`types`],
      listLines: (state) => state[`lines`],
      listClients: (state) => state[`clients`],
      listAdresses: (state) => state[`adresses`],
      listProduct: (state) => state[`products`],
      listProductsLines: (state) => state[`productsLines`],
      listProductsLinesCount: (state) => state[`productsLinesQtd`],
      listQuotesItems: (state) => state[`items`],
      listLoading: (state) => state[`${route}Loading`],
      form: state => state.quote,
      savingOrder: state => state.savingOrder
    })
  },
  watch: {
    form() {
      this.setData();
    },
    listClients() {
      this.setData();
    },
    listQuotesItems() {
      this.form.TOTAL = this.listQuotesItems.reduce((aux, item) => { 
        if (item.TOTAL > 0) {
          return aux + item.TOTAL;
        }
        return aux;
      }, 0);
      this.validateFreightTerms();
      this.saveToLocalStorage();
    },
    listLines() {
      if (this.listLines.length === 0) {
        return;
      }

      let lines = this.listLines

      if (lines && lines.length ) {
        lines = lines.map(item => ({value: item.name, label: item.name}))
        lines.sort((a, b) => a.value.localeCompare(b.value))
      }

      this.headersLines.forEach(item => {
        if (item.value === 'line' && lines && lines.length) {
          item.items = lines.map(item => ({text: item.label, value: item.value}))
        }

        if (item.value === 'type') {
          item.items = this.listTypes.map(item => ({text: item.name, value: item.name}))
        }
      });
    },
    listProductsLines() {
      if (this.listProductsLines.length > 0 && this.listQuotesItems.length > 0) {
        this.listQuotesItems.forEach(quoteItem => {
          this.listProductsLines.map(group => {
            return group.items.map(product => {
              if (quoteItem.sku === product.sku) {
                product.qty = quoteItem.QTY;
              }
              return product;
            });
          });
        });
      }
    },
    search(filtro) {
      if (!filtro || filtro.length < 3) {
        this.$store.commit(`${appStore}/cleanStateProduct`);
        return;
      }
      if (this.options.product && this.options.product.name === filtro) {
        return;
      }
      clearTimeout(this._timerId);
      let parameters = {
        search: filtro,
        customer: this.filled.CLIENTE.NAME,
        location: this.form.ADDRESS.LOCATION
      };
      this._timerId = setTimeout(() => this.$store.dispatch(`${appStore}/getProduct`, parameters), 400);
    },
    quoteTab() {
      if (this.quoteTab > 0) {
        this.cleanState = true;
        this.page = 1;
        this.selectedLine();
      }
    },
    optionsProductsLines: {
      handler () {
        this.selectedLine();
      },
      deep: true
    }
  },
  created() {
    EventBus.$on("change::isLoadingSearch", (loading) => {
      this.isLoadingSearch = loading;
    });
  },
  mounted() {
    this.$store.commit(`${appStore}/cleanState`);
    this.$store.dispatch(`${appStore}/getParameters`);
    if (this.salesQuote) {
      this.$store.dispatch(`${appStore}/getById`, this.salesQuote);
    }

    this.filterableHeadersLines = this.headersLines.filter(item => item.filterable)
  },
  methods: {
    dateToUSNoHour,
    getDiscountedPrice(item) {
      if (!item.discount_amount) {
        return item.price_unit
      }

      item.price_unit_discounted = item.price_unit * (1.0 - (item.discount_amount / 100.0))

      return item.price_unit_discounted
    },
    getTotalDiscountedPrice(item) {
      const discounted = this.getDiscountedPrice(item)
      const qty = item.QTY || 1

      item.total_price_unit_discounted = discounted * qty

      return item.total_price_unit_discounted
    },
    keepRange(item, field, min, max) {
      if (!item[field]) {
        return
      }

      if (item[field] < min) {
        item[field] = min
      }

      if (item[field] > max) {
        item[field] = max
      }
    },
    currencyUSA,
    ...mapActions([`${appStore}/getParameters`]),
    setData() {
      let dateNow = moment().format('YYYY-MM-DD');
      this.form.REQUEST_DATE = this.getWorkingDays().format('YYYY-MM-DD');
      if (this.salesQuote) {
        if (this.listClients.length > 0) {
          this.filled.CLIENTE = this.listClients.find(item => item.FEIN === this.form.TAXPAYER_ID);
        }
        this.form.LAST_UPDATE_DATE = dateNow;
      } else {
        this.form.CREATION_DATE = dateNow;
      }
      if (this.filled.CLIENTE) {
        this.selectedClient(this.filled.CLIENTE);
      }
      if (this.form.ADDRESS) {
        this.multiple = this.form.ADDRESS;
        this.filled.FFA = this.form.ADDRESS.FFA || 0;
      }
      this.validateFreightTerms();
    },
    getWorkingDays() {
      let workingDays = 1;
      let dataDesejada = moment();

      while(workingDays <= 3) {
        dataDesejada = dataDesejada.add(1, 'days');
        if (dataDesejada.isoWeekday() < 6) { // 6 - Sábado, 7 - Domingo
          workingDays++;
        }
      }
      return dataDesejada;
    },
    selectedClient(cliente) {
      this.listAdressesClient = this.listAdresses[cliente.CUSTOMER];
      this.form.SALES_REP_NAME = cliente.SALESREP;
      this.customerFields.CATEGORY = cliente.CODE_CATEGORY;
      this.customerFields.CLASS = cliente.CLASS_CODE;
      this.customerFields.SALE_CHANNEL = cliente.SALE_CHANNEL;

      if (cliente.CUSTOMER_TERMS) {
        // @todo ARRUMAR
        // this.filled.PAYMENT_TERM = cliente.CUSTOMER_TERMS.split("-").slice(1).join("-");
      }
    },
    fetchSalesRepName(salesRepId) {
      let params = {
        salesrep: salesRepId
      };
      this.$store.dispatch(`${appStore}/getSalesRepName`, params).finally(() => this.cleanState = false);
    },
    cleanSearch() {
      this.filtersByColumn = {}
      this.selectedLine()
    },
    selectedAddress() {
      if (this.listQuotesItems.length > 0) {
        this.addItemsInChunks(this.listQuotesItems);
      }
      this.multiple = this.form.ADDRESS;
      this.filled.FFA = this.form.ADDRESS.FFA || 0;
    },
    textAdress(item) {
      return item.ADDRESS + ', ' + item.CITY + ' - ' + item.STATE;
    },
    clearProduct() {
      this.options = {
        product: undefined,
        qty: 0
      };
      if (this.$refs.product) {
        setTimeout(() => this.$refs.product[0].focus(), 100);
      }
    },
    selectedLine() {
      if (this.quoteTab > 0) {
        if (!this.filled.CLIENTE) {
          let parameters = {
            snackbar: true,
            color: "error",
            text: this.$i18n.t('companhiaObrigatorio')
          };
          EventBus.$emit("criarAlerta", parameters);
          return;
        }
        let params = {
          search: this.filtersByColumn,
          page: this.page,
          limit: this.itemsPerPage,
          clean: this.cleanState,
          customer: this.filled.CLIENTE.NAME,
          location: this.form.ADDRESS.LOCATION
        };
        params = Object.assign(params, this.optionsProductsLines);
        this.$store.dispatch(`${appStore}/getProductLine`, params).finally(() => this.cleanState = false);
      }
    },
    selectedProduct() {
      if (this.options.product) {
        this.options.qty = this.qtdBox(this.options.product);
        setTimeout(() => this.$refs.qty[0].focus(), 100);
      } else {
        this.options.qty = 0;
      }
    },
    formattedSelectedProduct(product) {
      let unitPrice = product.price_unit

      if (product.discount_amount) {
        unitPrice -= unitPrice * (product.discount_amount / 100)
      }

      return {
        TIGRE_CODE: product.sku,
        DESCRIPTION: product.name,
        LINE: product.line,
        PRICE: product.price,
        DISCOUNT_AMOUNT: product.discount_amount,
        PRICE_UNIT: unitPrice,
        PRICE_UNIT_DISCOUNTED: product.price_unit_discounted,
        TOTAL_PRICE_UNIT_DISCOUNTED: product.total_price_unit_discounted,
        // PRICE_LIST: product.price_list,
        QTY: product.QTY,
        BOX_QTY: product.box_qty,
        PALLET_QTY: product.pallet_qty,
        UNIDADE_PAIS: product.business_unit,
      }
    },
    onProductSelected(selectedProduct) {
      let product = this.formattedSelectedProduct(selectedProduct)

      if (!product || !this.filled.CLIENTE) {
        return;
      }

      let productQty = product.QTY || this.options.qty;

      if (!productQty) {
        return;
      }

      product.QTY = this.options.qty || product.QTY;
      if (!this.roundQuantityToPacketSize(product)) {
        let value = '';

        if (product.BOX_LINE > 0) {
          value += product.BOX_LINE + ' ' + this.$i18n.t('ou') + ' ';
        }

        value += product.BOX_QTY;

        let parameters = {
          snackbar: true,
          color: "error",
          text: this.$i18n.t('produtosLinhaDevemPedidosQuantidadesCompletas')
              .replace(":LINHA", product.LINE)
              .replace(":VALOR", value)
        };
        EventBus.$emit("criarAlerta", parameters);
        return;
      }

      product = [product];

      this.clearProduct();
      this.addItemsInChunks(product);
    },
    addItemsInChunks(products) {
      let chunks = lodash.chunk(products, this.config.chunkSize);
      chunks.forEach(items => {
        let parameters = { 
          customer: this.filled.CLIENTE.NAME, 
          location: this.form.ADDRESS.LOCATION,
          items: items 
        };
        this.$store.dispatch(`${appStore}/getCostSale`, parameters);
      });
    },
    roundQuantityToPacketSize(product) {
      if (product.QTY === product.BOX_QTY || product.QTY % product.BOX_QTY === 0) {
        return true;
      }
      if (product.QTY === product.BOX_LINE || product.QTY % product.BOX_LINE === 0) {
        return true;
      }
      return false;
    },
    saveToLocalStorage() {
      if (!this.salesQuote) {
        let stepData = { items: this.listQuotesItems, form: this.form, filled: this.filled };
        localStorage.setItem(name, JSON.stringify(stepData));
      }
    },
    removeItemAction(item) {
      let index = this.listQuotesItems.indexOf(item);
      if (index > -1) {
        this.listQuotesItems.splice(index, 1);
      }
      this.saveToLocalStorage();
    },
    openDialog(item) {
      this.dialog = true;
      this.dialogItem = Object.assign({}, item);
    },
    sendOrder() {
      if (this.$refs.formQuote.validate()) {
        let request = Object.assign(this.form, { ITENS: this.listQuotesItems, CUSTOMER: this.filled.CLIENTE });
        if (this.validateForm(request)) {
          this.$store.commit(`${appStore}/setSavingOrder`, true);
          this.$store.dispatch(`${appStore}/getSendOrder`, request);
      
          this.listQuotesItems = {};
          this.saveToLocalStorage();

          this.$refs.formQuote.reset();
        }
      }
    },
    validateForm(request) {
      let validate = request.ITENS.find((item) => item.loading);
      if (!request.ITENS.length || validate) {
        let parameters = {
          snackbar: true,
          color: "error",
          text: this.$i18n.t('nenhumItemSelecionadoItemSendoCalculado')
        };
        EventBus.$emit("criarAlerta", parameters);
        return false;
      }
      return true;
    },
    validateFreightTerms() {
      this.listFreight.map(item => {
        if (item.value === 'Prepay & Add') {
          item.disabled = this.form.TOTAL > this.filled.FFA;
        }
        if (item.value === 'Prepaid') {
          item.disabled = this.form.TOTAL <= this.filled.FFA;
        }
        return item;
      });
      let disabled = this.listFreight.find(item => item.disabled === true);
      if (this.form.FREIGHT_TERMS === 'Prepay & Add' || this.form.FREIGHT_TERMS === 'Prepaid') {
        if (disabled.value === 'Prepay & Add') {
          this.form.FREIGHT_TERMS = 'Prepaid';
        }
        if (disabled.value === 'Prepaid') {
          this.form.FREIGHT_TERMS = 'Prepay & Add';
        }
      }
    },
    pageCount(totalItems) {
      return Math.ceil(totalItems / this.itemsPerPage);
    },
    onEnter($event, callback, ...params) {
      if ($event.keyCode === 13) {
        callback(...params);
      }
    },
    qtdBox(product) {
      return product && product.box_qty ? product.box_qty : 1
    },
    refQtyLines(index) {
      return "qtyLines_" + index.toString();
    },
    calculatePriceUnit(dialogItem) {
      dialogItem.PRICE_UNIT = parseFloat(dialogItem.MULTIPLE * dialogItem.PRICE).toFixed(4);
      dialogItem.PENDENCY = true;
    },
    calculateMultiple(dialogItem) {
      dialogItem.MULTIPLE = parseFloat(dialogItem.PRICE_UNIT / dialogItem.PRICE).toFixed(4);
      dialogItem.PENDENCY = true;
    },
    saveAddress() {
      if (this.$refs.formLocation.validate()) {
        let cliente = Object.assign({}, this.filled.CLIENTE);
        delete cliente.LOCATION;
        this.location = Object.assign(this.location, cliente);
        this.$store.commit(`${appStore}/setAddress`, this.location);
        this.form.ADDRESS = this.location;
        this.selectedAddress();
        this.dialogLocation = false;
      }
    }
  }
}
</script>